import { MagicStructureDefinition } from './magic-structure-def.model';

export class MagicFormInstanceDefinition extends MagicStructureDefinition {
    public constructor(formInstanceIdParam: number) {
        super();

        this.formInstanceId = formInstanceIdParam;

        return;
    }

    public formInstanceId: number;
}
